<template>
  <div class="container">
    <div class="row">
      <span>待转移用户邀请码：</span>
      <i-Input style="width:180px" type="text" v-model="user1" />

    </div>
    <div  class="row">
      <span>目标用户邀请码：</span>
      <i-Input style="width:180px" type="text" v-model="user2" />
    </div>
    <div class="btn-row">
      <Button type="primary" style="margin-right: 30px;" @click="seeAssets">查看资产</Button>
      <Button type="primary" :disabled="confirmButton" @click="handleTransfer">{{buttonContent}}</Button>
    </div>
    <div class="property-content">
      <div>{{user1Content}}</div>
      <div>{{user2Content}}</div>
    </div>

    <Modal
      @on-ok="confirmTransfer"
      title="确认转移资产？"
      v-model="confirmModal"
      :closable="false"
      :mask-closable="false"
    >
      <p>资产转移操作不可逆！</p>
    </Modal>
  </div>
</template>

<script>
import apis from "../../http/api";

export default {
  data() {
    return {
      user1: '',
      user2: '',
      confirmModal: false,
      confirmButton: false,
      buttonContent: '确认转移',
      user1Content: "",
      user2Content: ""
    }
  },
  async created() {
  },
  watch: {
  },
  methods: {
    handleTransfer() {
      this.confirmModal = true
    },
    confirmTransfer() {
      this.confirmButton = true
      this.buttonContent = '转移中...'
      let params = {
        'from_user_invite_code': this.user1,
        'to_user_invite_code': this.user2
      }
      apis.co_user_property_shift(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          alert('操作成功')
        }else {
          this.$Message.error(msg);
        }
        this.confirmButton = false
        this.buttonContent = '确认转移'
        this.seeAssets()
      }).catch(err=>{
        this.confirmButton = false
        this.buttonContent = '确认转移'
      })
    },
    seeAssets() {
      let params1 = {
        'invite_code': this.user1,
        'server_type': 0
      }
      let params2 = {
        'invite_code': this.user2,
        'server_type':1
      }
      apis.co_user_property(params1).then(res=>{
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.user1Content = data.string
        }else {
          this.$Message.error(msg);
        }
      }).catch()
      apis.co_user_property(params2).then(res=>{
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.user2Content = data.string
        }else {
          this.$Message.error(msg);
        }
      }).catch()
    },
  },
  computed: {
  }
}
</script>

<style scoped>
.container {
  padding: 30px;
}

.row {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.btn-row {
  margin-top: 50px;
}

.property-content{
  display: flex;
  padding-top: 40px;
}

  .property-content div{
    width: 30%;
    white-space: pre-wrap;
  }
</style>
